import { Language, RootState, Status } from '../types';

export const getLanguagesStatus = (state: RootState): Status => state.languages.status;

export const getLanguagesErrorMsg = (state: RootState): string | null => state.languages.errorMsg;

export const getLanguages = (state: RootState): Language[] => state.languages.languages;
